import { Box, Button, Typography } from "@mui/material";
import { useWhoAmIQuery } from "../../../api/whoAmI";
import { WhoAmIError } from "./WhoAmIError";
import { TokenTimeRemaining } from "./TokenTimeRemaining";
import { useToken } from "../../../store/token";
import { tokenExpiryDateUnix } from "../utils";
import { NoWhoAmI } from "./NoWhoAmI";
import type { ReactElement } from "react";
import { Loading } from "../../Loading";

interface WhoAmIProps {
  onClose: () => void;
  onValidate: () => void;
}

export const WhoAmI = ({ onValidate, onClose }: WhoAmIProps): ReactElement => {
  const token = useToken();
  const millisRemaining = tokenExpiryDateUnix(token);
  const { data: whoAmI, loading, error } = useWhoAmIQuery();

  if (loading) return <Loading />;
  if (error != null) return <WhoAmIError onClose={onClose} />;
  if (!whoAmI) return <NoWhoAmI onClose={onClose} />;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography variant="h4">Valid Token</Typography>
      <Typography>
        This is a token for {whoAmI.FirstName} {whoAmI.LastName}
      </Typography>

      <Typography>
        username: {whoAmI.UniqueName} ({whoAmI.Identifier})
      </Typography>
      <Typography sx={{ mt: 2 }}>Your token is valid for an extra:</Typography>
      <Typography sx={{ mt: 2 }} variant="h4" component="code">
        <TokenTimeRemaining />
      </Typography>
      <p />
      <Typography sx={{ textAlign: "justify" }}>
        If you don't think that's enough time. Log out of Brightspace, log in
        and run the command again. A fresh token should have 1h before expiring.
        I recommend at least 10 minutes.
      </Typography>
      <p></p>
      <Button disabled={millisRemaining < 0} onClick={onValidate}>
        OK
      </Button>
    </Box>
  );
};
